module.exports = __webpack_public_path__ + "static/img/1.718a8799.webp";